export class MICE
{
	loadHotel (id)
	{
		let _this = this;
		$.ajax({
			url: "/ajax.php?mid=45&action=loadHotel",
			type: 'POST',
			data: {id: id},
			dataType: "html",
			success: function(html){
				if (_this.popupHotelSwiper) {
					_this.popupHotelSwiper.destroy(true, true); // Уничтожить слайдер
					_this.popupHotelSwiper = null; // Обнулить переменную
				}

				$('.popup-hotel .popup__container').replaceWith($(html).find('.popup__container'));
				$('.popup-hotel').addClass("active");
				$("body").addClass("no-scroll");

				_this.applyEvents();
			},
			error: function(err){
				if (err.statusText === "abort") {
					// Запрос был прерван, можно просто проигнорировать
					console.warn('Запрос был прерван.');
				} else {
					// Обработка остальных ошибок
					alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
				}
			}
		});
	}

	loadTour (id)
	{
		let _this = this;
		$.ajax({
			url: "/ajax.php?mid=45&action=loadTour",
			type: 'POST',
			data: {id: id},
			dataType: "html",
			success: function(html){
				if (_this.popupExcursionSwiper) {
					_this.popupExcursionSwiper.destroy(true, true); // Уничтожить слайдер
					_this.popupExcursionSwiper = null; // Обнулить переменную
				}

				$('.popup-excursion .popup__container').replaceWith($(html).find('.popup__container'));
				$('.popup-excursion').addClass("active");
				$("body").addClass("no-scroll");

				_this.applyEvents();
			},
			error: function(err){
				if (err.statusText === "abort") {
					// Запрос был прерван, можно просто проигнорировать
					console.warn('Запрос был прерван.');
				} else {
					// Обработка остальных ошибок
					alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
				}
			}
		});
	}

	applyEvents()
	{
		const popupHotelGallery = document.querySelector('.popup-hotel__gallery');
		const popupExcursionGallery = document.querySelector('.popup-excursion__gallery');
		
		// Функция для управления слайдером
		const screenWidth = window.innerWidth;

		if (popupHotelGallery) {
			if (screenWidth < 1024) {
				// Если экран меньше 1024 и слайдер еще не инициализирован
				if (!this.popupHotelSwiper) {
					this.popupHotelSwiper = new Swiper(".popup-hotel__gallery", {
						modules: [Navigation],
						slidesPerView: 1,
						spaceBetween: 16,
						breakpoints: {
							768: {
								slidesPerView: 1,
								spaceBetween: 24
							},
						},
						navigation: {
							nextEl: '.popup-hotel__gallery-nav-btn--next',
							prevEl: '.popup-hotel__gallery-nav-btn--prev'
						}
					});
				}
			} else {
				// Если экран >= 1024 и слайдер уже инициализирован
				if (this.popupHotelSwiper) {
					this.popupHotelSwiper.destroy(true, true); // Уничтожить слайдер
					this.popupHotelSwiper = null; // Обнулить переменную
				}
			}
		}

		if (popupExcursionGallery) {
			if (screenWidth < 1024) {
				// Если экран меньше 1024 и слайдер еще не инициализирован
				if (!this.popupExcursionSwiper) {
					this.popupExcursionSwiper = new Swiper(".popup-excursion__gallery", {
						modules: [Navigation],
						slidesPerView: 1,
						spaceBetween: 16,
						breakpoints: {
							768: {
								slidesPerView: 1,
								spaceBetween: 24
							},
						},
						navigation: {
							nextEl: '.popup-excursion__gallery-nav-btn--next',
							prevEl: '.popup-excursion__gallery-nav-btn--prev'
						}
					});
				}
			} else {
				// Если экран >= 1024 и слайдер уже инициализирован
				if (this.popupExcursionSwiper) {
					this.popupExcursionSwiper.destroy(true, true); // Уничтожить слайдер
					this.popupExcursionSwiper = null; // Обнулить переменную
				}
			}
		}
	}
}